import React, { useState } from "react";
import { motion } from "framer-motion";
import useAnimationSettings from "../../../hooks/useAnimationSettings";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

export default function NuevoItem({
  titulo,
  desc,
  img,
  tecnologias = [],
  url,
}) {
  const [imageUnavailable, setImageUnavailable] = useState(false);
  const { reduceMotion, allowHoverAnimations, durations, offsets, viewport } =
    useAnimationSettings();

  return (
    <motion.article
      initial={reduceMotion ? false : { opacity: 0, y: offsets.revealY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={viewport}
      transition={{ duration: reduceMotion ? 0 : durations.reveal, ease: "easeOut" }}
      className="motion-gpu w-full max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8 px-0 py-12 lg:gap-12"
    >
      {/* Imagen */}
      <div className="w-full lg:w-1/2 flex justify-center">
        <a href={url || "#"} target="_blank" rel="noreferrer" className="block w-full max-w-[21.25rem] sm:max-w-[30rem]">
          {imageUnavailable ? (
            <div
              className="small-copy flex aspect-video items-center justify-center rounded-2xl border p-6 font-medium"
              style={{ color: VIOLETA, backgroundColor: `${VIOLETA}0D`, borderColor: `${VIOLETA}25` }}
            >
              Vista previa no disponible
            </div>
          ) : <img
            src={img}
            alt={titulo}
            decoding="async"
            loading="lazy"
            onError={() => setImageUnavailable(true)}
            className={`motion-gpu aspect-video rounded-2xl w-full object-contain transition-transform duration-300 ${
              allowHoverAnimations ? "hover:scale-[1.02]" : ""
            }`}
          />}
        </a>
      </div>

      {/* Descripción */}
      <div className="min-w-0 w-full lg:w-1/2 text-center lg:text-left">
        <a href={url || "#"} target="_blank" rel="noreferrer">
          <h3
            className="card-title mb-5 tracking-tight"
            style={{ color: VIOLETA }}
          >
            {titulo}
          </h3>
        </a>

        <p
          className="body-copy mb-6"
          style={{ color: `${VIOLETA}CC` }}
        >
          {desc}
        </p>

        {/* Tecnologías */}
        <div className="mb-6 hidden flex-wrap justify-center gap-2 sm:flex lg:justify-start">
          {tecnologias.map((t) => (
            <span
              key={t}
              className="px-3 py-1 rounded-full text-sm font-medium"
              style={{
                color: "white",
                backgroundColor: VIOLETA,
              }}
            >
              {t}
            </span>
          ))}
        </div>

        {/* Botón */}
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={`motion-gpu inline-flex w-full items-center justify-center rounded-xl px-6 py-3 font-semibold text-white transition-transform duration-300 sm:w-auto ${
              allowHoverAnimations ? "hover:scale-[1.03]" : ""
            }`}
            style={{
              background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
            }}
          >
            Visitar Web →
          </a>
        )}
      </div>
    </motion.article>
  );
}
